@for (m of modules(); track m.id) {
  <fieldset class="picker__module">
    <legend class="picker__module-head">
      <input type="checkbox" [checked]="count(m) === m.permissions.length"
             [indeterminate]="count(m) > 0 && count(m) < m.permissions.length"
             [disabled]="readOnly()" (change)="moduleToggled.emit(m)" [attr.aria-label]="label(m)" />
      {{ label(m) }}
      <span class="picker__module-count">{{ count(m) }} / {{ m.permissions.length }}</span>
    </legend>
    <div class="picker__perms">
      @for (perm of m.permissions; track perm.key) {
        <label class="picker__perm" [class.picker__perm--off]="readOnly() || isLocked(perm)"
               [attr.title]="isLocked(perm) ? lockedTitle() : null">
          <input type="checkbox" [checked]="selected().has(perm.key)" [disabled]="readOnly() || isLocked(perm)"
                 (change)="toggled.emit(perm.key)" />
          <span>
            {{ label(perm) }}
            <span class="picker__perm-key">
              <code>{{ perm.key }}</code>
              @if (extras(); as tpl) {
                <ng-container *ngTemplateOutlet="tpl; context: { $implicit: perm }"></ng-container>
              }
            </span>
          </span>
        </label>
      }
    </div>
  </fieldset>
}
